import { render, staticRenderFns } from "./BaseInputCurrency.vue?vue&type=template&id=7a815ab6&"
import script from "./BaseInputCurrency.vue?vue&type=script&lang=js&"
export * from "./BaseInputCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports